import Vue from 'vue'
import VueRouter from 'vue-router'
import { publicPath } from '../../vue.config'
//import { baseUrl } from '../../vue.config'


Vue.use(VueRouter)

  const routes = [
  { path: '*', redirect: '/' },
  //{ path: '/', name: 'home', component: () => import('@/components/home.vue') },
  { path: '/', name: 'inicio', component: () => import('@/components/inicio.vue') },
  
  { path: '/inicio', name: 'inicio', component: () => import('@/components/inicio.vue') },
  //{ path: '/acc', name: 'acc', params: true, component: () => import('@/components/acc.vue') },
  { path: '/acc', name: 'acc', params: true },
  { path: '/enc', name: 'enc', params: true },
  { path: '/res', name: 'res', params: true },
  { path: '/encuesta', name: 'encuesta', component: () => import('@/components/encuesta.vue'), props: { r: 0 } },

  { path: '/catalogo', name: 'catalogo', component: () => import('@/components/catalogo.vue') },
  { path: '/normativas', name: 'normativas', component: () => import('@/components/normativas.vue') },
  { path: '/verano', name: 'verano', component: () => import('@/components/verano.vue') },
  { path: '/solicitar-verano', name: 'solicitar-verano', component: () => import('@/components/solicitar-verano.vue') },
  { path: '/campamentos', name: 'campamentos', component: () => import('@/components/campamentos.vue') },
  { path: '/idiomas', name: 'idiomas', component: () => import('@/components/idiomas.vue') },

  { path: '/vacantes', name: 'vacantes', component: () => import('@/components/vacantes.vue') },
  { path: '/vacantesNo', name: 'vacantesNo', component: () => import('@/components/vacantes.vue') },
  { path: '/vacantes-campamentos', name: 'vacantes-campamentos', component: () => import('@/components/vacantes-campamentos.vue') },
  { path: '/reservas', name: 'reservas', component: () => import('@/components/reservas.vue') },
  { path: '/condiciones-generales', name: 'condiciones-generales', component: () => import('@/components/condiciones-generales.vue') },
  { path: '/cookies', name: 'cookies', component: () => import('@/components/cookies.vue') },
    
]

const router = new VueRouter(
{
  base: publicPath,
  mode: 'history', 
  routes,

  scrollBehavior() {
    return {x: 0, y: 0} 
  },
  
})

router.beforeEach((to, from, next) => {
  //console.log('ROUTER',from,to);

  //if (to.name !== 'login' && !isAuthenticated) {
  //  next({ name: 'login' });
  //} else {
    next();
  //}
});

export default router

